import { render, staticRenderFns } from "./GrupoProdutoModalPromotor.vue?vue&type=template&id=c736f202&scoped=true"
import script from "./GrupoProdutoModalPromotor.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoModalPromotor.vue?vue&type=script&lang=js"
import style0 from "./GrupoProdutoModalPromotor.vue?vue&type=style&index=0&id=c736f202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c736f202",
  null
  
)

export default component.exports